import type { PropsWithChildren } from "react";

import { TextTestID } from "@/constants/TestID";
import { CheckBox, Text, TextTag } from "@/ui/core";
import { BaseCard, HStack, VStack } from "@/ui/layout";
import { joinTestIDs } from "@/utils/string.util";

interface NotificationSettingsCardProps
  extends ViewWithTestID, PropsWithChildren {
  isChecked?: boolean;
  isDisabled?: boolean;
  isRecommended?: boolean;
  message?: string;
  onChange?: (isChecked: boolean) => void;
  title: string;
}

const NotificationSettingsCard = ({
  children,
  isChecked,
  isDisabled,
  isRecommended,
  message,
  onChange,
  testID,
  title,
}: NotificationSettingsCardProps) => {
  return (
    <BaseCard testID={joinTestIDs(testID, TextTestID.Card)}>
      <VStack gap={12}>
        <HStack alignItems="center" justifyContent="space-between">
          <HStack gap={12}>
            <CheckBox
              isChecked={isChecked}
              isDisabled={isDisabled}
              onChange={onChange}
              testID={testID}
            />
            <Text
              testID={joinTestIDs(testID, TextTestID.Title)}
              variant="bodyMedium"
            >
              {title}
            </Text>
          </HStack>
          {isRecommended && <TextTag text="Recommended" variant="highlight" />}
        </HStack>
        {message && (
          <Text testID={joinTestIDs(testID, TextTestID.Text)} variant="caption">
            {message}
          </Text>
        )}
        {children || null}
      </VStack>
    </BaseCard>
  );
};

export type { NotificationSettingsCardProps };
export default NotificationSettingsCard;
